import { track as amplitudeTrack } from '@amplitude/analytics-browser';
import qs from 'qs';

export const track = (event, properties = {}) => {
  const searchParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const theme = searchParams.theme || 'bookipi';
  if (theme !== 'bookipi') return;

  let source_app = window.location.hostname;

  // for pages rendered in an iframe
  if (window.parent !== window) {
    const ancestorOrigins = document.location?.ancestorOrigins;
    source_app = ancestorOrigins ? ancestorOrigins[ancestorOrigins.length - 1] : document.referrer || source_app;
  }

  amplitudeTrack(event, {
    platform: 'web',
    ...properties,
    source: window.location.origin,
    source_app
  });
};
